<button (click)="showSlsDialog()" class="shortcut-menu__button">
  <svg-icon src="assets/images/icons/tick-circle.svg"></svg-icon>
  <span>{{ "ShortcutMenu.Availability" | translate }}</span>
</button>
